import { Anchor } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import Link from 'next/link';

export default function RunHistoryHomeCrumb({ projectId, showIcon }: { projectId: string; showIcon?: boolean }) {
  return (
    <Anchor
      href={`/project/${projectId}/history`}
      component={Link}
      className="text-sm text-zinc-500 dark:text-zinc-400"
    >
      <div className="flex flex-row items-center gap-1">
        {showIcon ?
          <IconArrowLeft size={14} />
        : null}
        <span>Run History</span>
      </div>
    </Anchor>
  );
}
